'use client'

import type { ChangeEvent } from 'react'

import { Button, Icon, SearchBar } from '@graftcode/design-system'
import clsx from 'clsx'

import styles from './SearchFilter.module.scss'

interface SearchFilterBarProps {
  searchQuery: string
  placeholder?: string
  onSearchChange: (event: ChangeEvent<HTMLInputElement>) => void
  onSearchClear: () => void
  onFilterToggle?: () => void
  filterButtonDisabled?: boolean
}

export function SearchFilterBar({
  searchQuery,
  placeholder = 'Search libraries...',
  onSearchChange,
  onSearchClear,
  onFilterToggle,
  filterButtonDisabled = false,
}: SearchFilterBarProps) {
  const showFilterButton = onFilterToggle !== undefined || filterButtonDisabled
  const filterDisabled = filterButtonDisabled || onFilterToggle === undefined

  return (
    <div className={styles.searchAndFilters}>
      <div className={styles.container}>
        <SearchBar
          className={styles.searchBar}
          value={searchQuery}
          onChange={onSearchChange}
          onClear={onSearchClear}
          placeholder={placeholder}
          size="md"
          version="white"
        />
        {showFilterButton && (
          <Button
            iconOnly
            size="l"
            variant="ghost"
            icon={Icon.OptionsRegular}
            onClick={filterDisabled ? undefined : onFilterToggle}
            disabled={filterDisabled}
            className={clsx(styles.filterButton, filterDisabled && styles.disabled)}
            aria-label="Filter"
          />
        )}
      </div>
    </div>
  )
}
